import { Chip, Typography, Tooltip } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { Indicador } from '../../modelo/dominio/Indicador';


interface IProps {
    indicadores: Indicador[];
}

export const ViewIndicadores = observer(class ViewIndicadores extends React.Component<IProps> {
    render() {
        return (
            <div>
                {
                    this.props.indicadores && this.props.indicadores.length > 0 &&
                    <div>
                        <Typography component='b' variant='h6' className="titulo" tabIndex={3}>Indicadores:</Typography>
                        <div>
                            {this.props.indicadores.map((indicador, index) => {
                                if (indicador.isEtiqueta) {
                                    return <Tooltip key={indicador.descricao} title='Chip PJe'><Chip key={index} style={{ marginBottom: '5px', marginLeft: '6px' }} label={indicador.descricao} color="success" variant="outlined" /></Tooltip>;
                                } else {
                                    return <Tooltip key={indicador.descricao} title='Indicador'><Chip key={index} style={{ marginBottom: '5px', marginLeft: '6px' }} label={indicador.descricao} color="primary" variant="outlined" /></Tooltip>;
                                }
                            }
                            )}
                        </div>
                    </div>
                }
            </div>
        );
    }
});
